import { Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges,HostBinding,AfterViewInit } from '@angular/core';

import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
declare var $:any;



@Component({
  selector: 'privacy',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './privacy.component.html',

})
export class PrivacyComponent implements OnInit {


    homeSubscription:any;
 
    @HostBinding('style.width') public width: string = '100%'; 
     
   
  constructor( msg:MessageService,  toastr: ToastrService, homeservice:HomeService , _router: Router ){


    try{
 
 
      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
 
      if(!tokenA) throw 'Error in parse';
     
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
 
 
      tokenA = JSON.parse(tokenA);
              
  
 
 
      this.homeSubscription=  homeservice.homeData(tokenA.token).subscribe( (res) =>{
   
   //     console.log(res);
 
        if(res.status=='success'){
 
 
         msg.sendMessage({'user':res.user,'type':'left_menu_link','navigations':res.navigation,'notification':res.notification})
 
 
 
       }else{
 
         _router.navigate(['/login']);
 
       }
      
 
    });
 
 
 
    }catch(exc){
        
      _router.navigate(['/login']);
 
    } 
  
 
   }
 
   ngOnInit(){
  
 
   }
 
  
   ngOnDestroy(){
 
     if(this.homeSubscription){
 
      this.homeSubscription.unsubscribe();
       
      }   
     
   }

}
